import { useContext } from 'react';

import { Context } from '../context';

export const useLeadAction = () => useContext(Context);
